import * as types from '../types/couponTypes';
import { validateCoupon as validateCouponRequest } from '../../services/couponService';

/**
 * @param {{ code: string, subtotal?: number, items?: unknown[] }} params
 * @returns {Promise<{ success: boolean, data?: unknown, message?: string, error?: string }>}
 */
export const validateCoupon = ({ code, subtotal = 0, items = [] }) => async (dispatch) => {
  dispatch({ type: types.VALIDATE_COUPON_REQUEST });
  try {
    const res = await validateCouponRequest(code, subtotal, items);
    if (res?.success && Number(res?.data?.discountAmount) > 0) {
      dispatch({ type: types.VALIDATE_COUPON_SUCCESS, payload: res.data });
      return { success: true, data: res.data };
    }
    const msg = res?.message || 'Invalid coupon';
    dispatch({ type: types.VALIDATE_COUPON_FAILURE, payload: msg });
    return { success: false, message: msg };
  } catch (error) {
    const msg = error.response?.data?.message || error.message || 'Could not validate coupon';
    dispatch({ type: types.VALIDATE_COUPON_FAILURE, payload: msg });
    return { success: false, error: msg };
  }
};

export const clearCouponError = () => (dispatch) => {
  dispatch({ type: types.CLEAR_COUPON_ERROR });
};
